<div  class="w-full justify-center items-center flex flex-col bg-gray-500/10 animate-pulse h-80 mt-2 rounded-lg">{{utils.traslatei18n('notElementFound')}}</div>